import React, { Component } from 'react';
import { KMLItem } from './KMLItem/KMLItem';

import './KMLList.css'
export class KMLList extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }

        console.log(this.props.height);
    }

    componentDidMount() {
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <div className='kmlUploadTool__historyList' style={{ maxHeight: this.props.height}}>
                {
                    this.props.data.list.map((item)=>{
                        return (
                            <KMLItem key={item.name} data={item} showAttributes={this.props.data.showAttributes}/> 
                        );
                    })
                }                           
            </div>
        );
    }   
}